<template>
  <div class="approval-business-type-page">
    <basic-container>
      <el-card shadow="never" class="bt-card">
        <div slot="header" class="card-header">
          <span class="card-title">审批业务类型</span>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">
            新增业务类型
          </el-button>
        </div>

        <el-alert
          title="说明：业务类型编码需与代码中已注册的审批 Handler 的 getBusinessType() 一致，否则提交审批时报未注册的审批业务类型。"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 16px"
        />

        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          empty-text="暂无业务类型，请点击右上角新增业务类型配置"
        >
          <el-table-column label="序号" width="70" align="center" type="index" :index="1" />
          <el-table-column prop="typeCode" label="类型编码" min-width="220" align="center">
            <template slot-scope="scope">
              <span class="code-text">{{ scope.row.typeCode }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="类型名称" min-width="140" align="center" />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 'ENABLE' ? 'success' : 'info'"
                size="small"
              >
                {{ scope.row.status === "ENABLE" ? "启用" : "停用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="170" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-edit" @click="openDialog(scope.row)">
                编辑
              </el-button>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </basic-container>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑业务类型' : '新增业务类型'"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @open="handleDialogOpen"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="类型编码" prop="typeCode">
          <el-input
            v-model="form.typeCode"
            :disabled="!!form.id"
            placeholder="如 PRICE_BOOK_MERCHANT_ADJUST"
            maxlength="64"
          />
          <div v-if="!form.id" class="form-tip">
            必须与代码中 Handler 的 getBusinessType() 一致，保存后不可修改
          </div>
        </el-form-item>
        <el-form-item label="类型名称" prop="typeName">
          <el-input v-model="form.typeName" placeholder="如：价盘调价" maxlength="64" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="ENABLE">启用</el-radio>
            <el-radio label="DISABLE">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findApprovalBusinessTypeList,
  saveApprovalBusinessType,
  deleteApprovalBusinessType,
} from "@/api/work/waterProof/approval";

export default {
  name: "approvalBusinessType",
  data() {
    return {
      loading: false,
      saving: false,
      tableData: [],
      dialogVisible: false,
      form: {
        id: "",
        typeCode: "",
        typeName: "",
        status: "ENABLE",
      },
      rules: {
        typeCode: [
          { required: true, message: "请输入类型编码", trigger: "blur" },
          {
            pattern: /^[A-Z][A-Z0-9_]*$/,
            message: "请输入大写字母/数字/下划线，如 PRICE_BOOK_MERCHANT_ADJUST",
            trigger: "blur",
          },
        ],
        typeName: [{ required: true, message: "请输入类型名称", trigger: "blur" }],
      },
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    parseData(res) {
      if (!res || res.data == null) return {};
      if (typeof res.data === "string") {
        try {
          return JSON.parse(res.data) || {};
        } catch (e) {
          console.log("parseData error:", e);
          return {};
        }
      }
      return res.data;
    },
    handleList() {
      this.loading = true;
      findApprovalBusinessTypeList()
        .then((res) => {
          if (res.code === "200") {
            const data = this.parseData(res);
            this.tableData = Array.isArray(data)
              ? data
              : data.rows || data.list || [];
          } else {
            this.$message.error(res.message || "加载失败");
          }
        })
        .catch((err) => {
          console.log("findApprovalBusinessTypeList error:", err);
          this.$message.error("加载异常");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDialogOpen() {
      this.$refs.form && this.$refs.form.clearValidate();
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          typeCode: row.typeCode,
          typeName: row.typeName,
          status: row.status || "ENABLE",
        };
      } else {
        this.form = {
          id: "",
          typeCode: "",
          typeName: "",
          status: "ENABLE",
        };
      }
      this.dialogVisible = true;
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        saveApprovalBusinessType({
          typeCode: this.form.typeCode,
          typeName: this.form.typeName,
          status: this.form.status,
        })
          .then((res) => {
            if (res.code === "200") {
              this.$message.success("保存成功");
              this.dialogVisible = false;
              this.handleList();
            } else {
              this.$message.error(res.message || "保存失败");
            }
          })
          .catch((err) => {
            console.log("saveApprovalBusinessType error:", err);
            this.$message.error("保存异常");
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    handleDelete(row) {
      this.$confirm(
        `确定删除业务类型"${row.typeName}"吗？删除后仅从配置下拉中移除，不影响已配置的流程数据。`,
        "提示",
        { type: "warning" }
      )
        .then(() => {
          deleteApprovalBusinessType(row.id)
            .then((res) => {
              if (res.code === "200") {
                this.$message.success("删除成功");
                this.handleList();
              } else {
                this.$message.error(res.message || "删除失败");
              }
            })
            .catch((err) => {
              console.log("deleteApprovalBusinessType error:", err);
              this.$message.error("删除异常");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.approval-business-type-page {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-title {
      font-weight: 600;
    }
  }
  .code-text {
    font-family: Consolas, Monaco, monospace;
    color: #409eff;
    font-size: 13px;
  }
  .form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.6;
    margin-top: 4px;
  }
}
</style>
